import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import {
  animateGems,
  animateMatch2Boosters,
} from 'src/game/animation/CurrencyAnimation';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import {
  Match2Reward,
  isRandomReward,
} from 'src/replicant/match2/rewards/match2-rewards.ruleset';

export class LeaguesPrize extends View {
  private readonly icon: ImageScaleView;
  private readonly text: LangBitmapFontTextView;
  private reward?: Match2Reward;
  private amount?: number;

  constructor(opts: ViewOpts & { labelSize?: number; labelWidth?: number }) {
    super({
      width: 80,
      height: 80,
      ...opts,
    });

    this.icon = new ImageScaleView({
      superview: this,
      x: 0,
      y: 0,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      align: 'center',
      verticalAlign: 'center',
      width: this.style.width,
      height: this.style.height,
      image: 'assets/ui/match2/tournament/star_tournament_score_bg.png',
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: 0,
      y: this.style.height * 0.25,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: opts.labelSize ?? 20,
      font: 'Title',
      width: opts.labelWidth ?? 80,
      height: this.style.height,
    });
  }

  public setup(params: Match2Reward) {
    this.reward = params;

    if ('amount' in params && !isRandomReward(params)) {
      if (params.type === 'gems') {
        this.amount = params.amount;
        this.icon.updateOpts({
          image: 'assets/ui/shared/icons/gem.png',
        });
        this.text.updateOpts({
          localeText: () => `x${params.amount}`,
        });
      }

      if (params.type === 'boosters' && params.subType === 'dart') {
        this.amount = params.amount;
        this.icon.updateOpts({
          image: matchTheme().getUIAsset('booster_dart.png'),
        });
        this.text.updateOpts({
          localeText: () => `x${params.amount}`,
        });
      }
    }
  }

  public async grantReward(
    root: View,
    {
      scale = 1,
      centerAnchor = true,
    }: { scale?: number; centerAnchor?: boolean } = {},
  ) {
    const superview = root;
    const position = this.getPosition(superview);
    if (centerAnchor) {
      position.x += position.width / 2;
      position.y += position.height / 2;
    }

    if (this.reward?.type === 'gems') {
      await animateGems({
        superview,
        start: { position, scale },
        count: this.amount!,
      });
    }

    if (
      this.reward?.type === 'boosters' &&
      !isRandomReward(this.reward) &&
      this.reward.subType === 'dart'
    ) {
      await animateMatch2Boosters({
        superview,
        start: { position, scale },
        type: 'dart',
        count: this.amount!,
      });
    }
  }
}
